// extracted by mini-css-extract-plugin
export default {"cards":"Cards_cards__yAZ5U","card":"Cards_card__CtL-J","pa-m":"Cards_pa-m__MnLLF","row":"Cards_row__27rCU"};